<template>
	<div class="container-list">
		<div class="downloadInformation">
			<!-- <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        单位信息
      </div> -->
			<el-button type="primary" @click="importTemplate">模板下载</el-button>
		</div>

		<!-- 隐患信息 -->

		<el-form ref="form" :model="form" label-width="110px" class="mt20" v-show="nowIndex == 0">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="单位名称" prop="base.c_name">
						<!-- <el-input v-model="form.base.c_name"></el-input> -->
						<span>{{ form.base.c_name }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6" style="">
					<el-form-item label="社会信用代码" prop="base.c_imployee_number " class="">
						<div class="flex">
							<!-- <el-input v-model="form.base.c_imployee_number" style="width:10%"></el-input> -->
							<span>{{ form.base.c_imployee_number }}</span>
						</div>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item
            label="单位编号"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="base.c_number"
          >
            <el-input v-model="form.base.c_number"></el-input>
          </el-form-item>
        </el-col> -->

				<el-col :span="6">
					<el-form-item label="所属辖区">
						<span>{{ form.base.area }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="详细地址" prop="base.c_address">
						<!-- <el-input v-model="form.base.c_address"></el-input> -->
						<span>{{ form.base.c_address }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="安全监管级别" prop="base.c_safe_level">
						<!-- <v-select :value.sync="form.base.c_safe_level" :id="38"></v-select> -->
						<span>{{ form.base.c_safe_level_name }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="所属集团" prop="base.c_superior">
						<el-select disabled v-model="form.base.c_superior">
							<el-option v-for="item in shangjioption" :key="item.value" :label="item.key" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="所属园区" prop="base.c_part">
						<el-select disabled v-model="form.base.c_part">
							<el-option v-for="item in yuanqvoption" :key="item.value" :label="item.key" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="所属行业" prop="base.c_belong_profession">
						<!-- <v-select
              :value.sync="form.base.c_belong_profession"
              :id="66"
            ></v-select> -->
						<span>{{ form.base.c_belong_profession_name }}</span>
					</el-form-item>
				</el-col>

				<!-- <el-col :span="6">
          <el-form-item label="安装信息表" prop="base.c_setup_table">
            <el-radio-group v-model="form.base.c_setup_table">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="省" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_province">-->
				<!--                        <el-select v-model="form.base.c_province" placeholder="请选择省份" @change="proChanege">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in allAreaList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="市" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_city">-->
				<!--                        <el-select v-model="form.base.c_city" placeholder="请选择市" @change="cityChanege">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in cityList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="区" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_area">-->
				<!--                        <el-select v-model="form.base.c_area" placeholder="请选择区">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in areaList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->

				<!-- <el-col :span="6">
          <el-form-item
            label-width="140px"
            label="消防安全重点单位"
            prop="base.c_import_company"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-radio-group v-model="form.base.c_import_company">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->

				<el-col :span="6">
					<el-form-item label="消防安全责任人" prop="base.c_responsible">
						<!-- <el-input v-model="form.base.c_responsible"></el-input> -->
						<span>{{ form.base.c_responsible }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="责任人联系方式" prop="base.c_phone">
						<!-- <el-input v-model="form.base.c_phone"></el-input> -->
						<span>{{ form.base.c_phone }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="消防安全管理人">
						<!-- <el-input v-model="form.base.c_manager"></el-input> -->
						<span>{{ form.base.c_manager }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="管理人联系方式">
						<!-- <el-input v-model="form.base.c_manager_phone"></el-input> -->
						<span>{{ form.base.c_manager_phone }}</span>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item label="部门负责人" prop="base.c_department_responsible">
            <el-input v-model="form.base.c_department_responsible"></el-input>
          </el-form-item>
        </el-col> -->
				<!-- <el-col :span="6">
          <el-form-item
            label-width="140px"
            label="部门负责人联系方式"
            prop="base.c_video_filter"
          >
            <el-input v-model="form.base.c_video_filter"></el-input>
          </el-form-item>
        </el-col> -->
				<el-col :span="6">
					<el-form-item label="点位数量" prop="base.c_woker" :disabled="true">
						<!-- <el-input v-model="form.base.dwnum"></el-input> -->
						<span>{{ form.base.dwnum }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="职工数" prop="base.c_woker">
						<!-- <el-input v-model="form.base.c_woker"></el-input> -->
						<span>{{ form.base.c_woker }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="占地面积" prop="base.c_land_area">
						<!-- <el-input v-model="form.base.c_land_area"></el-input> -->
						<span>{{ form.base.c_land_area }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="总建筑面积" prop="base.c_total_area">
						<!-- <el-input v-model="form.base.c_total_area"></el-input> -->
						<span>{{ form.base.c_total_area }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="邮箱" prop="base.c_orgin_num">
						<!-- <el-input v-model="form.base.c_orgin_num"></el-input> -->
						<span>{{ form.base.c_orgin_num }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="建筑产权单位" prop="base.c_power_company ">
						<!-- <el-input v-model="form.base.c_power_company"></el-input> -->
						<span>{{ form.base.c_power_company }}</span>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item label="级别" prop="base.c_level">
            <el-input v-model="form.base.c_level"></el-input>
          </el-form-item>
        </el-col> -->

				<!-- <el-col :span="6">
          <el-form-item label="类型" prop="base.c_profession_type">
            <el-input v-model="form.base.c_profession_type"></el-input>
          </el-form-item>
        </el-col> -->

				<!-- <el-col :span="24">
          <el-form-item label="消防隐患" prop="base.c_firefighting_messsage">
            <el-input v-model="form.base.c_firefighting_messsage"></el-input>
          </el-form-item>
        </el-col> -->

				<el-col :span="24">
					<el-form-item label="单位简介" prop="base.c_bim_href">
						<!-- <el-input
              type="textarea"
              :rows="5"
              v-model="form.base.c_bim_href"
            ></el-input> -->
						<p>{{ form.base.c_bim_href }}</p>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<div v-for="(item, index1) in tabList" v-show="nowIndex == 0 && index1 == 1" v-if="index1 !== 0">
			<div class="f-right">
				<div class="flex1 mt20">{{ item.title }}</div>
			</div>
			<!-- <div class="btn-box">
        <div class="btn ml10" @click="addList(index1)">
          <i class="icon-tr-newly-added"></i>新增
        </div>
      </div> -->

			<table class="common-table mt20">
				<thead>
					<tr>
						<th v-for="data in item.data">
							{{ data.text }}
						</th>
						<!-- <th>操作</th> -->
					</tr>
				</thead>
				<tbody>
					<tr v-for="(data, index) in form[tabList[index1].form]">
						<td class="common-add" v-for="(input, key, index2) in tabList[index1].data">
							<!-- <el-input
                placeholder="请输入"
                v-model="form[tabList[index1].form][index][input.form_name]"
                v-if="input.type == 'text'"
              ></el-input> -->
							<span style="color: #000; font-size: 16px" class="mt20">{{ form[tabList[index1].form][index][input.form_name] }}</span>
							<div v-if="input.type == 'select'">
								<v-select :value.sync="form[tabList[index1].form][index][input.form_name]" :id="input.op_id || input.option"></v-select>
							</div>
							<el-date-picker
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="选择日期"
								v-model="form[tabList[index1].form][index][input.form_name]"
								v-if="input.type == 'date'"
							></el-date-picker>
							<el-time-picker
								type="time"
								value-format="HH:mm:ss"
								placeholder="选择时间"
								v-model="form[tabList[index1].form][index][input.form_name]"
								v-if="input.type == 'timmer'"
							></el-time-picker>
						</td>
						<!-- <td class="td-btn">
              <a class="clear-data" @click="del(index)">
                <i class="icon-tr-delete"></i>
              </a>
            </td> -->
					</tr>
				</tbody>
			</table>
			<el-row class="mt20">
				<div class="f-right">
					<div class="flex1 mt20">建筑资料</div>
				</div>
				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传图纸资料：</span>
						<fileUpload
							v-model="form.base.buildDrawInfoURL"
							disabled
							:uploadData="{ flagType: '0' }"
							:fileType="['dwg', 'pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:limit="5"
							:fileSize="10"
						/>
					</div>
				</el-col>
				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传审批手续资料:</span>
						<fileUpload
							v-model="form.base.buildApprovalProcedureInfoURL"
							disabled
							:uploadData="{ flagType: '0' }"
							:fileType="['pdf', 'jpg', 'png', 'zip']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:fileSize="10"
							:limit="5"
						/>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="60%">
			<img width="100%" :src="viewImgUrl" alt="" />
		</el-dialog>
		<!-- <div class="btn-box" v-if="nowIndex !== tabList.length">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back(-1)">返回</div>
    </div> -->
	</div>
</template>
<script>
	import { getArea } from "../api/common";
	import { sigtype, port } from "../views/company/options";
	import getLoation from "../views/company/getLoation";
	import facility from "@/components/alarm.vue";
	import danger from "../views/company/danger";
	export default {
		data() {
			return {
				area: [],
				services: [],
				areaValue: ["370000", "370200", "370202"],
				shangjioption: [],
				yuanqvoption: [],
				form: {
					base: {
						leaseContractURL: "",
						buildDrawInfoURL: "",
						buildApprovalProcedureInfoURL: "",
						c_type: "",
						c_superior: "",
						c_name: "",
						c_phone: "",
						c_manager_phone: "",
						c_power_company: "",
						c_in_net: "",
						c_net_status: "",
						c_province: "370000",
						c_city: "370200",
						c_area: "370202",
						c_address: "",
						c_setup_table: "",
						isbim: "",
						c_safe_level: "",
						c_belong_profession: "",
						c_orgin_num: "",
						c_responsible: "",
						c_manager: "",
						c_imployee_number: "",
						c_woker: "",
						c_land_area: "",
						c_total_area: "",
						// c_firefighting_messsage: "",
						c_bim_href: "",
						c_port: "",
						c_plugin_type: "",
						lat: "",
						lon: "",
					},
					get_build: [],
					get_control: [],
					get_server: [],
					get_facility: [],
					get_transmission: [],
					get_interface: [],
					get_message: [],
					get_onduty: [],
					get_video: [],
				},
				rules: {},
				nowIndex: 0,
				viewImgUrl: "",
				dialogVisible: false,
				allAreaList: [],
				cityList: [],
				areaList: [],
				tabList: [
					{ title: "基本信息", form: "base" },
					{
						title: "建筑信息",
						form: "get_build",
						data: [
							{ form_name: "cb_name", type: "text", text: "建筑名称" },
							{ form_name: "cb_area", type: "text", text: "建筑面积" },

							{ form_name: "cb_use_type", type: "text", text: "使用性质" },
							{ form_name: "cb_height", type: "text", text: "高度" },
							{ form_name: "cb_on", type: "text", text: "地上层数" },
							{ form_name: "cb_under", type: "text", text: "地下层数" },
							// {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
						],
					},
				],
			};
		},

		watch: {
			dialogVisible(v) {
				if (!v) {
					this.viewImgUrl = "";
				}
			},
			c_num: function(val) {
				this.c_company_num = val;
				this.getList(val);
			},

			c_company_num: function(val) {
				this.$emit("c_num", val);
			},
		},
		props: ["c_num"],

		created() {
			this.$get("/trmonitor/area/FatherSonLinkageList?threeLevel=4").then((res) => {
				this.area = res.data;
			});
			this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemap").then((res) => {
				var arr = [];
				var arr1 = [];

				res.data[0].map((item, index) => {
					arr.push({ key: item.c_name, value: item.company_num });
				});
				res.data[1].map((item, index) => {
					arr1.push({ key: item.c_name, value: item.company_num });
				});
				arr.unshift({ key: "无", value: "0" });
				arr1.unshift({ key: "无", value: "0" });

				this.shangjioption = arr;
				this.yuanqvoption = arr1;
			});
			this.getList(this.c_num);
		},

		mounted() {},
		components: {
			getLoation,
			facility,
			danger,
		},
		methods: {
			importTemplate() {
				console.log(this.$config.apiUrl, this.$route.query.id);
				// downLoadExcel("/trmonitor/company/downloadCompanyBaseTemplate");
				//  window.open(`${this.$config.apiUrl}/trxf/main/xf/downloadFireUrl?id=${this.$route.query.id}`);
				//'https://wuliantest.tongren119.com/v1/trxf/main/xf/downloadFireUrl?id=ee7a45afdd0540d59efc25eb7f3bde74'
				window.open(`${this.$config.apiUrl}/trxf/main/xf/downloadFireUrl?id=${this.$route.query.id}`);
			},
			//图片查看
			viewImg(type) {
				this.viewImgUrl = this.form.base[type];
				this.dialogVisible = true;
			},
			handlechange() {
				this.form.base.c_port = this.services.join(",");
			},
			getList(c_num) {
				if (c_num) {
					this.$get("/trxf/main/xf/danwei/xfdanweixinxi/detailbaseFire/" + c_num).then((res) => {
						this.form = res.from;

						//this.areaValue = [res.from.base.c_province,res.from.base.c_city,res.from.base.c_area]
					});
				}
				// this.$post("/checklist/seruritytablefindone", {
				//   c_company_num: c_num,
				// }).then((res) => {
				//   if (res.data.length) {
				//     var data = JSON.parse(res.data[0].company_json).base.ww_problem;
				//     this.form.base.c_firefighting_messsage = data;
				//   }
				// });
			},
			areaChange(val) {
				log(val);
				this.form.base.c_province = val[0];
				this.form.base.c_city = val[1];
				this.form.base.c_area = val[2];
			},
			getLoa(val) {
				this.form.base.lon = String(val[0]);
				this.form.base.lat = String(val[1]);
			},
			proChanege(flag) {
				this.cityList = [];
				this.areaList = [];
				flag !== 1 && (this.form.base.c_city = "");
				flag !== 1 && (this.form.base.c_area = "");
				this.allAreaList.forEach((it) => {
					if (it.area_code == this.form.base.c_province) {
						this.cityList = it.city;
					}
				});
			},
			cityChanege(flag) {
				this.areaList = [];
				!flag && (this.form.base.c_area = "");
				this.cityList.forEach((it) => {
					if (it.area_code == this.form.base.c_city) {
						this.areaList = it.get_area;
					}
				});
			},
			addList(index) {
				let obj = {};
				this.tabList[this.nowIndex].data.forEach((it) => {
					obj[it.form_name] = "";
				});
				this.form[this.tabList[this.nowIndex].form].push(obj);
			},
			del(index) {
				this.form[this.tabList[this.nowIndex].form].splice(index, 1);
			},
			changeTab(index) {
				this.nowIndex = index;
			},
		},
	};
</script>

<style scoped>
	::v-deep .el-form-item__label {
		text-align: center;
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		font-weight: 900;
		line-height: 40px;
		padding: 0 12px 0 0;
		box-sizing: border-box;
	}
	::v-deep .el-input.is-disabled .el-input__inner {
		background-color: none;
		border-color: none;
		color: #000;
		background: none;
		border: none;
	}
	::v-deep .el-select .el-input.is-disabled .el-input__inner {
		cursor: auto;
	}
	::v-deep .el-select .el-input .el-select__caret {
		display: none;
	}
	.downloadInformation {
		display: flex;
		justify-content: flex-end;
	}
</style>
